export default "__VITE_ASSET__CxbQeg2r__"